/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Device } from '../model/device';
import { DeviceLog } from '../model/deviceLog';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DevicesApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get one device by Id
     * Retrieves detailed information for a specific device by its ID.
     * @param id Device ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDeviceById(id: number, observe?: 'body', reportProgress?: boolean): Observable<Device>;
    public getDeviceById(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Device>>;
    public getDeviceById(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Device>>;
    public getDeviceById(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDeviceById.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Device>('get',`${this.basePath}/device/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get device logs
     * 
     * @param name The name of the device
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDeviceLogs(name: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DeviceLog>>;
    public getDeviceLogs(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DeviceLog>>>;
    public getDeviceLogs(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DeviceLog>>>;
    public getDeviceLogs(name: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getDeviceLogs.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DeviceLog>>('get',`${this.basePath}/operation/log/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all devices
     * Retrieves a list of devices filtered based on the user&#x27;s role and associated permissions.  Returns device details along with status and location info. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDevices(observe?: 'body', reportProgress?: boolean): Observable<Array<Device>>;
    public getDevices(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Device>>>;
    public getDevices(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Device>>>;
    public getDevices(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Device>>('get',`${this.basePath}/device/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
